import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import EditableProMode from 'components/Editor/cource/layout/controls/ElementControls/EditableProMode'
import { t } from 'services/Translation'

import { ElementGroup } from '../../elements.types'
import { genElementConfig } from '../../genElementConfig'
import RichTextDemo from './RichTextDemo'
import RichTextElement from './RichTextElement'
import RichTextFormBrand from './RichTextFormBrand'
import RichTextFormValue from './RichTextFormValue'
import textIcon from './assets/richText.svg'

export default genElementConfig(CONFIG_ELEMENTS.richText, {
  label: t('elements.richText.label'),
  icon: textIcon,
  group: ElementGroup.view,
  styleFields: null,
  Element: RichTextElement,
  Demo: [RichTextDemo],
  FormValue: RichTextFormValue,
  FormBrand: RichTextFormBrand,
  EditorActions: EditableProMode,
})
